import { Company } from '../../../interfaces/company.interface';
import { User } from '../../../interfaces/user.interface';
import apiService from '../../../services/api-client';
import { PutMePasswordPayloadRequest, PutMePasswordResponse } from '../interfaces/put-me-password';
import { PutMeUserPayloadRequest, PutMeUserResponse } from '../interfaces/put-me-user';

export const meApiService = {
  async getMeUser() {
    const { data } = await apiService().get<User>(`users/me`);
    return data;
  },
  async putMeUser(body: PutMeUserPayloadRequest) {
    const { data } = await apiService().put<User>(`users/me`, body);
    return data;
  },
  async getMeCompanies() {
    const { data } = await apiService().get<Company[]>(`/users/me/companies`);
    return data;
  },
  async putMePassword(body: PutMePasswordPayloadRequest) {
    const { data } = await apiService().put<PutMePasswordResponse>(`users/me/change-password`, {
      current_password: body.currentPassword,
      new_password: body.newPassword
    });
    return data;
  },
};
